import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { useNotificationsStore } from '../../store/notifications.store';

const useStyles = makeStyles({
  container: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    padding: '8px',
    marginRight: '8px',
    borderRadius: '4px',
    transition: 'background-color 0.2s',
    '&:hover': {
      backgroundColor: 'rgba(255, 255, 255, 0.1)',
    },
  },
  icon: {
    fontSize: '18px',
    color: 'rgba(255, 255, 255, 0.8)',
    transition: 'color 0.2s',
  },
  iconActive: {
    color: 'var(--accent-1-color)',
  },
  badge: {
    position: 'absolute',
    top: '2px',
    right: '2px',
    minWidth: '16px',
    height: '16px',
    padding: '0 4px',
    borderRadius: '8px',
    backgroundColor: 'var(--accent-1-color)',
    color: '#fff',
    fontSize: '10px',
    fontWeight: 600,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    lineHeight: 1,
  },
});

/**
 * NotificationBell Component
 *
 * Displays a bell icon with a badge showing the count of pending notifications.
 * Clicking opens the appropriate pending licenses/requests modals.
 */
const NotificationBell: React.FC = () => {
  const classes = useStyles();

  const pendingLicensesCount = useNotificationsStore(state => state.pendingLicensesCount);
  const rejectedRequestsCount = useNotificationsStore(state => state.rejectedRequestsCount);
  const pendingRequestsCount = useNotificationsStore(state => state.pendingRequestsCount);
  const expiredLicensesCount = useNotificationsStore(state => state.expiredLicensesCount);
  const expiringSoonCount = useNotificationsStore(state => state.expiringSoonCount);
  const licenseClaimedCount = useNotificationsStore(state => state.licenseClaimedCount);
  const openNotifications = useNotificationsStore(state => state.openNotifications);

  const totalCount =
    pendingLicensesCount +
    rejectedRequestsCount +
    pendingRequestsCount +
    expiredLicensesCount +
    expiringSoonCount +
    licenseClaimedCount;

  // Don't render if no notifications
  if (totalCount === 0) {
    return null;
  }

  const handleClick = () => {
    openNotifications();
  };

  return (
    <div
      className={classes.container}
      onClick={handleClick}
      title={`${totalCount} pending notification${totalCount !== 1 ? 's' : ''}`}
    >
      <i className={`tim-icons icon-bell-55 ${classes.icon} ${totalCount > 0 ? classes.iconActive : ''}`} />
      {totalCount > 0 && (
        <span className={classes.badge}>
          {totalCount > 99 ? '99+' : totalCount}
        </span>
      )}
    </div>
  );
};

export default NotificationBell;
